<ngb-alert #selfClosingAlert class="m-0" *ngIf="!staticAlertClosed" [type]="alert.type" (closed)="close()" [dismissible]="true">{{ alert.serverMessage ? alert.serverMessage : alert.localMessage }}
</ngb-alert>
